export default function popupCorona() {
  const content = $('[data-corona="content"]');
  const close = $('[data-corona="close"]');

  if (localStorage.getItem('popup')) {
    content.hide();
  }

  close.click(() => {
    content.hide();
    localStorage.setItem('popup', true);
  })
}